/**
 * Remove tabindex from video player wrapper
 */

const $ = window.jQuery;

export default {
  attach: function(context, settings) {
    window.requestAnimationFrame(function() {
      $(once('videoAccessibilityFix','.video-upload',context)).each(function () {
        $(this).find('.plyr').removeAttr('tabindex');
      });
    });
  }
}
